import styled from '@emotion/styled';

export const SadaAccountSettings = styled.div``;
